import {
  faCar,
  faBicycle,
  faChair,
  faHouse,
  faFlask,
  faLaptop,
  faTabletScreenButton,
  faMobileScreenButton,
  faPrint,
  faHammer,
  faUtensils,
  faPaw,
  faDumbbell,
} from '@fortawesome/free-solid-svg-icons';
import { IconType } from '../../__generated__/types';

export const ResourceIcons = [
  { icon: faCar, gqlName: IconType.FA_CAR_SOLID },
  { icon: faBicycle, gqlName: IconType.FA_BICYCLE_SOLID },
  { icon: faChair, gqlName: IconType.FA_CHAIR_SOLID },
  { icon: faHouse, gqlName: IconType.FA_HOUSE_BUILDING_SOLID },
  { icon: faFlask, gqlName: IconType.FA_FLASK_SOLID },
  { icon: faDumbbell, gqlName: IconType.FA_DUMBBELL_SOLID },
  { icon: faLaptop, gqlName: IconType.FA_LAPTOP_SOLID },
  {
    icon: faTabletScreenButton,
    gqlName: IconType.FA_TABLET_SCREEN_BUTTON_SOLID,
  },
  {
    icon: faMobileScreenButton,
    gqlName: IconType.FA_MOBILE_SCREEN_BUTTON_SOLID,
  },
  { icon: faPrint, gqlName: IconType.FA_PRINT_SOLID },
  { icon: faHammer, gqlName: IconType.FA_HAMMER_BRUSH_SOLID },
  { icon: faUtensils, gqlName: IconType.FA_UTENSILS_SOLID },
  { icon: faPaw, gqlName: IconType.FA_PAW_SOLID },
] as const;

export const getIconByGraphQLName = (
  gqlName: IconType | null | undefined
): (typeof ResourceIcons)[number] | null => {
  return gqlName
    ? ResourceIcons.find((i) => i.gqlName === gqlName) ?? null
    : null;
};
